import React from 'react';

const SectionTitle = (props) => {
    return (
        <div className="sec-title centered">
            <h1 style={{marginBottom: "10px"}}>{props.title}</h1>
            <div className="title"  style={{
                'background': 'repeating-linear-gradient(45deg, #fff7ed, #fff7ed 10px, #ffedd5 10px, #ffedd5 20px)',
                'color': '#de0b0b',
                'padding': '18px 22px'
            }}>{props.header}</div>
            <div className="separator"></div>
            {/* <div style={{ marginBottom: "40px", textAlign: "center" }}>
                <h2
                    style={{
                        fontSize: "36px",
                        fontWeight: "700",
                        marginBottom: "12px",
                        color: "#000"
                    }}
                >
                    {props.title}
                </h2>

                <p
                    style={{
                        fontSize: "24px",
                        margin: "0 auto",
                        lineHeight: "1.7",
                        color: "#555"
                    }}  
                >
                    {props.header}
                </p>
            </div> */}

        </div>
    );
};

export default SectionTitle;